var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      staticClass: "ma-0",
    },
    [
      _c("v-col", { attrs: { cols: _vm.env === "ax" ? 5 : 6 } }),
      _c("v-spacer"),
      _c(
        "v-col",
        { staticClass: "px-8 pt-0", attrs: { cols: _vm.env === "ax" ? 7 : 6 } },
        [
          _c("div", { staticStyle: { "min-height": "125px" } }, [
            _c(
              "div",
              {
                staticClass: "pr-16 background pt-10",
                class: _vm.env === "ax" ? "col-7" : "col-6",
                staticStyle: {
                  position: "fixed",
                  "z-index": "10",
                  "min-height": "100px",
                },
                style:
                  _vm.scroll > 100
                    ? "box-shadow: 2px 4px 6px -6px rgba(69, 90, 100, 0.15);"
                    : "",
              },
              [
                _c(
                  "v-toolbar",
                  {
                    staticClass: "mb-2 transparent",
                    attrs: { flat: "", height: "46", "min-width": "100%" },
                  },
                  [
                    _c("v-toolbar-title", { staticClass: "text-h4 pa-0" }, [
                      _vm._v("Organizaciones"),
                    ]),
                  ],
                  1
                ),
                _c("v-divider"),
              ],
              1
            ),
          ]),
          _c(
            "v-card",
            { staticClass: "mb-4 ml-3", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "pa-0 transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Información de la empresa")]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _vm.env !== "fc"
                    ? [
                        _c(
                          "v-col",
                          { staticClass: "px-5 mb-5", attrs: { cols: "5" } },
                          [
                            _c(
                              "span",
                              { staticClass: "grey-500--text body-1" },
                              [_vm._v("País")]
                            ),
                            _c("v-autocomplete", {
                              attrs: {
                                error: _vm.$v.newAccount.country.$error,
                                items: _vm.countriesList.slice(0, 2),
                                "append-icon": "mdi-chevron-down",
                                placeholder: "Selecciona el país",
                                "single-line": "",
                                "item-text": "name",
                                "item-value": "id",
                                "hide-details": "",
                                dense: "",
                                height: "30",
                                outlined: "",
                              },
                              model: {
                                value: _vm.$v.newAccount.country.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.newAccount.country,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.newAccount.country.$model",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _c(
                    "v-row",
                    {
                      class: [`px-5`, { "mt-6": _vm.env !== "fc" }],
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "px-0", attrs: { cols: "8" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre de la empresa"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.newAccount.name.$error,
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newAccount.name.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newAccount.name,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.newAccount.name.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _vm.newAccount.country
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "ml-1 grey-500--text body-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.env === "fc"
                                          ? "RUT"
                                          : _vm.translate[
                                              _vm.newAccount.country
                                            ]
                                      ) + " "
                                    ),
                                  ]
                                ),
                                _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "dni",
                                      rawName: "v-dni",
                                      value: _vm.newAccount.country,
                                      expression: "newAccount.country",
                                    },
                                  ],
                                  attrs: {
                                    error: _vm.$v.newAccount.tax_id.$error,
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    maxlength: "64",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.$v.newAccount.tax_id.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.newAccount.tax_id,
                                        "$model",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "$v.newAccount.tax_id.$model",
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0 my-4", attrs: { cols: "5" } },
                        [
                          _c(
                            "span",
                            { staticClass: "ml-1 grey-500--text body-1" },
                            [_vm._v("Comuna")]
                          ),
                          _c("v-autocomplete", {
                            attrs: {
                              error: _vm.$v.newAccount.state.$error,
                              items: _vm.stateList,
                              "single-line": "",
                              "item-text": "name",
                              "append-icon": "mdi-chevron-down",
                              "item-value": "id",
                              "hide-details": "",
                              dense: "",
                              height: "30",
                              outlined: "",
                              "return-object": false,
                            },
                            model: {
                              value: _vm.$v.newAccount.state.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.newAccount.state, "$model", $$v)
                              },
                              expression: "$v.newAccount.state.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3 my-4" },
                        [
                          _c(
                            "span",
                            { staticClass: "ml-1 grey-500--text body-1" },
                            [_vm._v("Dirección")]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.newAccount.address.$error,
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "128",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newAccount.address.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newAccount.address,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.newAccount.address.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "py-0 px-5", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "6" } },
                        [
                          _c(
                            "span",
                            { staticClass: "ml-1 grey-500--text body-1" },
                            [_vm._v("Email de contacto")]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.newAccount.email.$error,
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "56",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.newAccount.email.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newAccount.email,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.newAccount.email.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.newAccount.country
                        ? _c(
                            "v-col",
                            { staticClass: "pa-0 ml-3" },
                            [
                              _c(
                                "span",
                                { staticClass: "ml-1 grey-500--text body-1" },
                                [_vm._v("Teléfono")]
                              ),
                              _c(
                                "vue-tel-input",
                                _vm._b(
                                  {
                                    key: _vm.reset,
                                    attrs: {
                                      id: "vue-tel-input-custom",
                                      error: _vm.$v.newAccount.phone.$error,
                                    },
                                    on: {
                                      "country-changed": _vm.changeCountry,
                                    },
                                    model: {
                                      value: _vm.$v.newAccount.phone.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.newAccount.phone,
                                          "$model",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "$v.newAccount.phone.$model",
                                    },
                                  },
                                  "vue-tel-input",
                                  _vm.bindProps,
                                  false
                                )
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-5 pt-0 my-5", attrs: { cols: "12" } },
                    [
                      _c(
                        "span",
                        { staticClass: "ml-1 grey-500--text body-1" },
                        [_vm._v("Sitio web")]
                      ),
                      _c("v-text-field", {
                        attrs: {
                          error: _vm.$v.newAccount.website.$error,
                          outlined: "",
                          required: "",
                          "single-line": "",
                          dense: "",
                          maxlength: "64",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.$v.newAccount.website.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.newAccount.website,
                              "$model",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "$v.newAccount.website.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 mt-6 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Información del receptor")]
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "mt-6 px-5 pb-3",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "px-0", attrs: { cols: "5" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pt-0 pl-3", attrs: { cols: "5" } },
                        [
                          _c(
                            "span",
                            { staticClass: "ml-1 grey-500--text body-1" },
                            [_vm._v("Email")]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              required: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "56",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        to: { name: "AuthChoose", params: _vm.$route.params },
                        outlined: "",
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.accounts.createLoader,
                        color: "grey-900",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createAccount()
                        },
                      },
                    },
                    [_vm._v("Crear organización")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }